module.exports = __webpack_public_path__ + "img/logo-m2n.5cb8d652.svg";